"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _keyCodes = require("../../helpers/keyCodes");

var EventHandler = /*#__PURE__*/function () {
  function EventHandler(setStateValues) {
    (0, _classCallCheck2["default"])(this, EventHandler);
    this.setStateValues = setStateValues;
    this.displayName = 'CCExpirationInputEventHandler';
    this.twoDigitsRegex = /^\d{2}$/;
    this.validKeyCodes = [].concat((0, _toConsumableArray2["default"])(_keyCodes.deleteKeys), (0, _toConsumableArray2["default"])(_keyCodes.movementKeys), (0, _toConsumableArray2["default"])(_keyCodes.numericKeys));
  }

  (0, _createClass2["default"])(EventHandler, [{
    key: "setValues",
    value: function setValues(rawValue) {
      var monthValue = (rawValue.split('/')[0] || '').slice(0, 2);
      var yearValue = "20".concat(rawValue.split('/')[1] || '').slice(0, 4);
      this.setStateValues({
        storedValue: rawValue,
        monthValue: monthValue,
        yearValue: yearValue
      });
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      var value = event.target.value;
      this.setValues(value);
    } // Key 'down' event is also handled here to handle keys held down

  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      this.handleKeyEvent(event);
    } // Key 'up' event is preferred here for inserting the '/'

  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      this.handleKeyEvent(event);
    }
  }, {
    key: "handleKeyEvent",
    value: function handleKeyEvent(event) {
      var keyCode = event.keyCode,
          value = event.target.value;

      if (_keyCodes.deleteKeys.includes(keyCode) || (0, _keyCodes.isMetaKeyPressed)(event)) {
        return;
      }

      if (!this.validKeyCodes.includes(keyCode)) {
        event.preventDefault();
        return;
      } // 2 digits have been entered, append '/' & update internal values


      if (value.match(this.twoDigitsRegex)) {
        this.setValues("".concat(value, "/"));
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      // https://reactjs.org/docs/events.html#event-pooling
      event.persist();
      this.setStateValues({
        dirty: event.target.value.length > 0,
        complete: true,
        isFocused: false
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setStateValues({
        dirty: true,
        isFocused: true
      });
    }
  }]);
  return EventHandler;
}();

var _default = EventHandler;
exports["default"] = _default;